import { Trans } from 'react-i18next';

import { fonts } from 'components/styles/variables';
import LoadingSpinner from 'components/Shared/LoadingSpinner';

function Loading(): JSX.Element {
  return (
    <>
      <div className="loading-container">
        <div className="spinner">
          <LoadingSpinner containerSize={64} spinnerSize={36} isWhite={false} />
        </div>
        <div className="header">
          <Trans i18nKey="onboarding.loadingScreen.header" components={[<br />]} />
        </div>
      </div>
      <style jsx>{`
        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 564px;
          justify-content: center;
          width: 295px;
        }
        .loading-content {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .header {
          text-align: center;
          font-family: ${fonts.default};
          font-weight: 700;
          font-size: 22px;
          line-height: 32px;
          letter-spacing: 0.2px;
          margin-bottom: 20px;
        }
      `}</style>
    </>
  );
}

export default Loading;
